module.exports = __webpack_public_path__ + "media/luxury-2026/estate-front-drone-960-e00442e9.jpg";